module.exports = __webpack_public_path__ + "img/app-cover.dc6c01a6.png";